import { useInjection } from 'inversify-react'

import T from '../../config/inversify.types'
import type { ErrorStore } from '../../store/error/error.store'

export function useErrorStore(): ErrorStore {
    return useInjection<ErrorStore>(T.ErrorStore)
}
